// Pantalla `command="login-otp"`. Port de la rama `when "login-otp"` de
// keycloak.coffee. Form de TOTP con app autenticadora. Si el usuario
// tiene varios dispositivos TOTP registrados, lista de radios para
// elegir uno. Checkbox "no volver a pedir en N días" si está
// configurado. Submit normal (no custom).

import type { FormEvent } from "react";
import type { KcData } from "../kcData";
import { Input } from "../components/Input";
import { StandardPage } from "../components/StandardPage";
import { msg } from "../i18n";

interface OtpCredential {
  id: string;
  userLabel?: string;
}

interface OtpConfig {
  credentials: OtpCredential[];
  selectedOtpCredentialId?: string;
  cookieTtlDays?: number | null;
  rememberChecked?: boolean;
}

function getOtpConfig(data: KcData): OtpConfig | undefined {
  return (
    (data.form?.otpConfig as OtpConfig | undefined) ??
    (data as unknown as { otpConfig?: OtpConfig }).otpConfig
  );
}

export interface LoginOtpPageProps {
  data: KcData;
  running: boolean;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
}

export function LoginOtpPage(props: LoginOtpPageProps) {
  const { data, running, onSubmit } = props;
  const otpConfig = getOtpConfig(data);
  const showOtpLabel =
    otpConfig != null && otpConfig.credentials.length > 1;

  const checkedCredentialId =
    otpConfig?.selectedOtpCredentialId ?? otpConfig?.credentials[0]?.id;

  return (
    <StandardPage page="login-otp" data={data}>
      <div>
        <form
          id="kc-totp-login-form"
          action={data.url!.loginAction}
          method="post"
          onSubmit={onSubmit}
        >
          {/* La frase contiene un <strong> inline; HTML pre-resuelto en la
              key para mantener una sola message i18n. */}
          <p
            className="instruction"
            dangerouslySetInnerHTML={{ __html: msg("loginOtpInstructionHtml") }}
          />
          {otpConfig && otpConfig.credentials.length > 1 ? (
            <div className="form-group otp-devices" id="otpDevicesContainer">
              <label>{msg("loginOtpDeviceLabel")}</label>
              {otpConfig.credentials.map((credential) => (
                <div className="otp-device" key={credential.id}>
                  <input
                    type="radio"
                    id={`selectedCredentialId_${credential.id}`}
                    name="selectedCredentialId"
                    value={credential.id}
                    defaultChecked={checkedCredentialId === credential.id}
                  />
                  <label
                    className="label-otp-device"
                    htmlFor={`selectedCredentialId_${credential.id}`}
                  >
                    {!credential.userLabel?.trim() ||
                    credential.userLabel === "unnamed" ? (
                      <span style={{ fontStyle: "italic" }}>
                        {msg("loginOtpUnnamedDevice")}
                      </span>
                    ) : (
                      credential.userLabel
                    )}
                  </label>
                </div>
              ))}
            </div>
          ) : null}
          <div className="form-group">
            {showOtpLabel ? (
              <label htmlFor="otp">{msg("loginOtpCode")}</label>
            ) : null}
            <Input
              type="number"
              className="form-control inputNumber"
              id="otp"
              name="otp"
              placeholder={msg("loginOtpCode")}
              autoFocus
              messagesPerField={data.messagesPerField}
            />
          </div>
          {otpConfig?.cookieTtlDays != null ? (
            <p className="checkbox otpCodeRemember">
              <label>
                <input
                  type="checkbox"
                  id="totpRemember"
                  defaultChecked={otpConfig.rememberChecked === true}
                  name="totpRemember"
                />
                {msg(
                  "rememberCodeForDays",
                  String(otpConfig.cookieTtlDays || 30),
                )}
              </label>
            </p>
          ) : null}
          <div className="form-group">
            <button
              type="submit"
              className="btn btn-lg btn-block btn-primary"
              id="kc-login"
              disabled={running}
            >
              {msg("doLogIn")}
            </button>
          </div>
        </form>
        <div className="form-group">
          <a href={data.url!.loginRestartFlowUrl} className="linkButton">
            <button
              className="btn btn-lg btn-block btn-default"
              disabled={running}
            >
              {msg("doCancel")}
            </button>
          </a>
        </div>
      </div>
    </StandardPage>
  );
}
